import { z } from "zod";
import { CompanySize, DurationType } from "../../../__generated__/graphql";

// Step 1: Company Information Schema
export const companyInformationSchema = z.object({
  organization: z.string().min(1, "Organization name is required"),
  roleInOrganization: z.string().min(1, "Your role is required"),
  industry: z.string().min(1, "Industry is required"),
  companySize: z.nativeEnum(CompanySize, {
    errorMap: () => ({ message: "Please select company size" }),
  }),
});

// Step 2: Contact Details Schema
export const contactDetailsSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
  phone: z.string().min(10, "Please enter a valid phone number"),
});

// Duration schema for job specifics
const durationSchema = z.object({
  type: z.nativeEnum(DurationType),
  value: z.number().positive("Duration must be positive"),
});

// Step 3: Job Consultation Schema
export const jobConsultationSchema = z.object({
  jobTitle: z.string().min(1, "Job title is required"),
  salaryRange: z.string().min(1, "Salary range is required"),
  employmentType: z.string().min(1, "Employment type is required"),
  duration: durationSchema,
  location: z.string().min(1, "Location is required"),
  expectedStartDate: z
    .date({
      required_error: "Expected start date is required",
      invalid_type_error: "Please enter a valid date",
    })
    .min(new Date(), "Expected start date must be in the future"),
});

// Combined schema using Zod merge for proper validation
export const recruitmentConsultationSchema = companyInformationSchema
  .merge(contactDetailsSchema)
  .merge(jobConsultationSchema);

export type CompanyInformationFormData = z.infer<
  typeof companyInformationSchema
>;
export type ContactDetailsFormData = z.infer<typeof contactDetailsSchema>;
export type JobConsultationFormData = z.infer<typeof jobConsultationSchema>;
export type RecruitmentConsultationFormData = z.infer<
  typeof recruitmentConsultationSchema
>;
